import styled from 'styled-components';

const StyledContainerPopover = styled.div`
  position: ${({ absolute }) => (absolute ? 'absolute' : 'relative')};
`;

export default StyledContainerPopover;
